import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-tattoremoval.jpg";
import heroImage1 from "../../../assets/images/ad-tattoremoval1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  ACNE: acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur, Selaiyur, Chitlapakkam",
    popularServices: [
      "Laser Tattoo Removal",
      "Q-Switched Laser Tattoo Removal",
      "Picosecond Laser Tattoo Removal",
      "Black Ink Tattoo Removal"
    ],
    specialties: "Tattoo Removal & Skin Correction",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam",
    popularServices: [
      "Multicolor Tattoo Removal",
      "Colored Tattoo Removal",
      "Tattoo Fading Treatment",
      "Complete Tattoo Removal"
    ],
    specialties: "Advanced Laser Tattoo Removal",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee, Nazarethpet, Thirumazhisai",
    popularServices: [
      "Safe Tattoo Removal",
      "Effective Tattoo Removal",
      "Minimal Scarring Tattoo Removal",
      "Professional Tattoo Removal"
    ],
    specialties: "Comprehensive Tattoo Removal Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout",
    popularServices: [
      "Best Tattoo Removal Bangalore",
      "Advanced Laser Tattoo Removal",
      "Tattoo Removal Consultation",
      "Tattoo Removal Aftercare"
    ],
    specialties: "Advanced Tattoo Removal & Dermatology",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After Tattoo Removal Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "Tattoo Removal Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced Tattoo Removal Equipment" },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("TATTO REMOVAL");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative Tattoo Removal Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Tattoremoval() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  
  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Tattoo Removal Treatment in Chennai, Bangalore | Laser Tattoo Removal Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Discover the best tattoo removal treatment in Chennai, Bangalore at H-Cura. Our advanced laser technology safely and effectively removes unwanted tattoos with minimal discomfort and scarring. Professional dermatological services available across Tamil Nadu, Karnataka, and Pondicherry."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "tattoo removal Chennai, laser tattoo removal Bangalore, tattoo removal clinic Tamil Nadu, dermatologist Karnataka, Q-switched laser tattoo removal Chennai Bangalore, picosecond laser tattoo removal specialist Tamil Nadu Karnataka, best tattoo removal clinic Chennai Bangalore, tattoo removal near me, multicolor tattoo removal Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, black ink tattoo removal Tamil Nadu Karnataka, colored tattoo removal Chennai Bangalore, tattoo fading treatment specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced tattoo removal Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, safe tattoo removal Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, effective tattoo removal Chennai Bangalore, minimal scarring tattoo removal Tamil Nadu Karnataka, professional tattoo removal Chennai Bangalore, unwanted tattoo removal Tamil Nadu Karnataka, tattoo removal consultation Tambaram Jayanagar, tattoo removal aftercare Valasaravakkam Koramangala, tattoo removal for all skin types Gerugambakkam BTM Layout, laser tattoo removal for black ink Chennai Bangalore, laser tattoo removal for colored ink Tamil Nadu Karnataka, tattoo removal services Chennai Bangalore, tattoo removal doctor Tamil Nadu Karnataka, tattoo removal center Chennai Bangalore, dermatology Chennai Bangalore, tattoo removal skincare clinic Tamil Nadu Karnataka, tattoo removal consultation Chennai Bangalore, tattoo removal skin analysis Tamil Nadu Karnataka, tattoo removal prevention Chennai Bangalore, tattoo removal skin health Tamil Nadu Karnataka, dermatological tattoo removal treatment Chennai Bangalore, cosmetic tattoo removal dermatology Tamil Nadu Karnataka, medical tattoo removal skincare Chennai Bangalore, professional tattoo removal treatment Tamil Nadu Karnataka, tattoo removal skin wellness Chennai Bangalore, tattoo removal dermatology services Tamil Nadu Karnataka, tattoo removal treatment Tambaram Gandhi Road Jayanagar, tattoo removal clinic Valasaravakkam Krishnamachari Nagar Koramangala, tattoo removal dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, tattoo removal doctor Chromepet Pallavaram JP Nagar Banashankari, tattoo removal skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, tattoo removal treatment clinic Virugambakkam Kundrathur Lalbagh, tattoo removal rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced tattoo removal and laser tattoo removal treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-tatto-removal-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        { "@type": "State", "name": "Tamil Nadu" },
        { "@type": "State", "name": "Karnataka" },
        { "@type": "State", "name": "Pondicherry" },
        { "@type": "City", "name": "Chennai" },
        { "@type": "City", "name": "Bangalore" },
        { "@type": "City", "name": "Bengaluru" },
        { "@type": "City", "name": "Pondicherry" },
        { "@type": "City", "name": "Puducherry" },
        // Chennai Areas
        { "@type": "City", "name": "Tambaram" }, { "@type": "City", "name": "Valasaravakkam" }, { "@type": "City", "name": "Gerugambakkam" },
        { "@type": "City", "name": "Chromepet" }, { "@type": "City", "name": "Pallavaram" }, { "@type": "City", "name": "Perungalathur" },
        { "@type": "City", "name": "Porur" }, { "@type": "City", "name": "Alwarthirunagar" }, { "@type": "City", "name": "Virugambakkam" },
        { "@type": "City", "name": "Kundrathur" }, { "@type": "City", "name": "Mangadu" }, { "@type": "City", "name": "Poonamallee" },
        { "@type": "City", "name": "Selaiyur" }, { "@type": "City", "name": "Chitlapakkam" }, { "@type": "City", "name": "Ramapuram" },
        { "@type": "City", "name": "Mugalivakkam" }, { "@type": "City", "name": "Nazarethpet" }, { "@type": "City", "name": "Thirumazhisai" },
        // Bangalore Areas
        { "@type": "City", "name": "Jayanagar" }, { "@type": "City", "name": "Koramangala" }, { "@type": "City", "name": "BTM Layout" },
        { "@type": "City", "name": "JP Nagar" }, { "@type": "City", "name": "Banashankari" }, { "@type": "City", "name": "Basavanagudi" },
        { "@type": "City", "name": "Wilson Garden" }, { "@type": "City", "name": "Lalbagh" }, { "@type": "City", "name": "Indiranagar" },
        { "@type": "City", "name": "Whitefield" }, { "@type": "City", "name": "Electronic City" }, { "@type": "City", "name": "HSR Layout" },
        { "@type": "City", "name": "Marathahalli" },
        // Pondicherry Areas
        { "@type": "City", "name": "White Town" }, { "@type": "City", "name": "Lawspet" }, { "@type": "City", "name": "Auroville" }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Selaiyur", "Chitlapakkam",
        "Ramapuram", "Mugalivakkam", "Nazarethpet", "Thirumazhisai", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh",
        "Indiranagar", "Whitefield", "Electronic City", "HSR Layout", "Marathahalli",
        
        // Pondicherry Areas
        "Pondicherry", "Puducherry", "White Town", "Lawspet", "Auroville"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Tattoo Removal",
        "Laser Tattoo Removal",
        "Q-Switched Laser",
        "Picosecond Laser",
        "Multicolor Tattoo Removal",
        "Black Ink Tattoo Removal"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Tattoo Removal Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Laser Tattoo Removal"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Q-Switched Laser Tattoo Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Picosecond Laser Tattoo Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Multicolor Tattoo Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Black Ink Tattoo Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Colored Tattoo Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Tattoo Fading Treatment"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent tattoo removal treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best laser tattoo removal treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing tattoo removal results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Tattoo Removal Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced tattoo removal and laser tattoo removal solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for clear, tattoo-free skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-tatto-removal-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Tattoo Removal Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced tattoo removal and laser tattoo removal solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Tattoo Removal, Laser Tattoo Removal, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-tatto-removal-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-tatto-removal-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Add favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Tattoo Removal Treatment",
          "item": "https://www.h-cura.com/advanced-tatto-removal-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for tattoo removal treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides tattoo removal treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of tattoo removal treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced Laser Tattoo Removal, Q-Switched Laser Tattoo Removal, Picosecond Laser Tattoo Removal, Multicolor Tattoo Removal, Black Ink Tattoo Removal, Colored Tattoo Removal, and Tattoo Fading Treatment across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for tattoo removal treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "Is tattoo removal painful?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our advanced laser tattoo removal procedures are designed to minimize discomfort. Patients typically describe the sensation as similar to a rubber band snapping against the skin. Topical anesthetics can be used to enhance comfort."
          }
        },
        {
          "@type": "Question",
          "name": "How many sessions are needed for complete tattoo removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The number of sessions varies depending on the tattoo's size, color, age, ink type, and location on the body. Typically, 6-12 sessions are required for complete removal, spaced 4-8 weeks apart. Our specialists will provide a personalized estimate during your consultation."
          }
        },
        {
          "@type": "Question",
          "name": "Will there be scars after tattoo removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our goal is to remove tattoos with minimal to no scarring. Modern laser technology significantly reduces the risk of scarring compared to older methods. Proper aftercare is crucial for optimal healing."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-tatto-removal-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-tatto-removal-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      
      if (e.key === 'ArrowLeft') {
        navigatePrevious(e);
      } else if (e.key === 'ArrowRight') {
        navigateNext(e);
      } else if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative Tattoo Removal Solutions for Clear Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge tattoo removal therapies designed to safely and effectively remove unwanted tattoos.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Tattoo Removal</h2>
            <p className="ads-nav-description">
              Our tattoo removal treatment combines advanced laser technology with
              expert techniques for optimal ink clearance and skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>Q-SWITCHED LASER TATTOO REMOVAL</strong>
                <p>Advanced Q-switched laser for effective ink breakdown.</p>
                <ul className="ads-treatment-details">
                  <li>Effective for Black and Dark Inks</li>
                  <li>Minimizes Skin Damage</li>
                  <li>Gradual Fading of Tattoos</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PICOSECOND LASER TATTOO REMOVAL</strong>
                <p>Ultra-fast picosecond laser for stubborn and colorful tattoos.</p>
                <ul className="ads-treatment-details">
                  <li>Treats a Wide Range of Colors</li>
                  <li>Fewer Sessions Required</li>
                  <li>Faster Ink Clearance</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>MULTICOLOR TATTOO REMOVAL</strong>
                <p>Specialized approach for tattoos with multiple ink colors.</p>
                <ul className="ads-treatment-details">
                  <li>Targets Different Pigments</li>
                  <li>Customized Laser Settings</li>
                  <li>Comprehensive Color Removal</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>BLACK INK TATTOO REMOVAL</strong>
                <p>Highly effective laser treatment for black ink tattoos.</p>
                <ul className="ads-treatment-details">
                  <li>Optimal for Darkest Inks</li>
                  <li>Fast and Efficient</li>
                  <li>Minimal Downtime</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>TATTOO FADING TREATMENT</strong>
                <p>Pre-cover-up fading or partial removal for new designs.</p>
                <ul className="ads-treatment-details">
                  <li>Prepares Skin for Cover-Ups</li>
                  <li>Lightens Existing Tattoos</li>
                  <li>Customizable Fading Levels</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our Tattoo Removal treatments are customized for each
              individual's tattoo type, size, and skin concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of Tattoo Removal.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Tattoo Removal Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Tattoo Removal Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Tattoo Removal Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                   INNOVATIVE TATTOO REMOVAL
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough laser treatments combine advanced technology,
                    precision targeting, and expert care to safely and effectively remove unwanted tattoos.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Tattoo Removal Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Effective Ink Removal" />
                      </span>{" "}
                      <strong>Effective Ink Removal</strong>
                      <p>Significant fading and clearance of various tattoo inks</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Minimal Scarring"
                        />
                      </span>{" "}
                      <strong>Minimal Scarring</strong>
                      <p>Advanced laser techniques reduce inflammation and prevent scarring</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Safe Procedure"
                        />
                      </span>{" "}
                      <strong>Safe Procedure</strong>
                      <p>Less chance of infection with professional and sterile practices</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Achieve noticeable results with minimal downtime or
                        discomfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>30-60 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Quick Recovery</p>
                    <span className="ads-subtitle">Immediate Results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced tattoo removal treatments combine clinical expertise with innovative
            technology to safely and effectively remove unwanted tattoos.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in tattoo removal technology (Q-switched, Picosecond lasers) for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your tattoo removal needs.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your tattoo's characteristics and skin type.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Minimal Scarring",
              desc: "Achieve clear skin with minimal to no scarring, ensuring natural-looking results.",
              features: [
                "Advanced laser techniques",
                "Optimal healing protocols",
                "Excellent cosmetic outcomes",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our tattoo removal facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have achieved tattoo-free skin with our solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Tattoo-Free, Clear Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for safe and effective
            tattoo removal.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your tattoo, skin type, and removal goals.",
              details: [
                "Detailed tattoo analysis (size, color, age, ink type)",
                "Skin assessment for suitability",
                "Customized treatment roadmap",
                "Expectation setting and personalized quote",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized tattoo removal plan just for you, selecting the optimal laser technology.",
              details: [
                "Individualized laser settings",
                "Session scheduling",
                "Pre-treatment care instructions",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert Laser Session",
              desc: "Experience our precise laser techniques for targeted and effective tattoo ink breakdown.",
              details: [
                "Sterile preparation and skin cooling",
                "Precise laser application with minimal discomfort",
                "Targeted ink fragmentation",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin heals optimally and achieves maximum ink clearance.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment adjustments",
                "Aftercare instructions for optimal healing",
                "Long-term support and maintenance plans",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Tattoo Removal Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Tattoo Removal Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced tattoo removal treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur, Selaiyur, Chitlapakkam areas with Laser Tattoo Removal, Q-Switched Laser Tattoo Removal, Picosecond Laser Tattoo Removal, Black Ink Tattoo Removal. 
          Specializing in Tattoo Removal & Skin Correction. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best tattoo removal treatment Tamil Nadu, laser tattoo removal specialist Chennai, dermatologist Tambaram, tattoo removal clinic Chromepet, tattoo removal treatment Pallavaram, Q-switched laser tattoo removal Perungalathur.
        </p>
        
        <h3>Tattoo Removal Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional tattoo removal services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam communities with Multicolor Tattoo Removal, Colored Tattoo Removal, Tattoo Fading Treatment, Complete Tattoo Removal. 
          Specializing in Advanced Laser Tattoo Removal. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Tattoo removal treatment Valasaravakkam, tattoo removal clinic Porur, tattoo removal dermatologist Alwarthirunagar, tattoo removal specialist Virugambakkam, multicolor tattoo removal Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Tattoo Removal Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive tattoo removal treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee, Nazarethpet, Thirumazhisai residents with Safe Tattoo Removal, Effective Tattoo Removal, Minimal Scarring Tattoo Removal, Professional Tattoo Removal. 
          Offering Complete Tattoo Removal Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Tattoo removal treatment Gerugambakkam, tattoo removal clinic Kundrathur, tattoo removal dermatologist Mangadu, tattoo removal specialist Poonamallee, safe tattoo removal Chennai Tamil Nadu.
        </p>

        <h3>Advanced Tattoo Removal Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier tattoo removal and laser tattoo removal services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout areas with Best Tattoo Removal Bangalore, Advanced Laser Tattoo Removal, Tattoo Removal Consultation, Tattoo Removal Aftercare. 
          Specializing in Advanced Tattoo Removal & Dermatology. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best tattoo removal treatment Bangalore, laser tattoo removal specialist Karnataka, dermatologist Jayanagar, tattoo removal clinic Koramangala, tattoo removal treatment BTM Layout, picosecond laser tattoo removal JP Nagar, 
          tattoo removal doctor Banashankari, multicolor tattoo removal Basavanagudi, dermatology Wilson Garden, tattoo removal treatment Lalbagh, tattoo removal clinic Bangalore Karnataka, laser tattoo removal specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides tattoo removal treatment and laser tattoo removal services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Tattoo removal treatment Bangalore, laser tattoo removal Karnataka, dermatologist Bengaluru, tattoo removal clinic Bangalore, tattoo removal specialist Karnataka, Q-switched laser tattoo removal Bangalore, 
          picosecond laser tattoo removal Karnataka, multicolor tattoo removal Bangalore, black ink tattoo removal Karnataka, colored tattoo removal Bangalore, tattoo fading treatment Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides tattoo removal treatment and laser tattoo removal services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Tattoo removal treatment Chennai, laser tattoo removal Tamil Nadu, dermatologist Chennai, tattoo removal clinic Tamil Nadu, tattoo removal specialist Chennai, Q-switched laser tattoo removal Tamil Nadu.
        </p>

        <h3>Advanced Tattoo Removal Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive tattoo removal treatment including Advanced Laser Tattoo Removal, Q-Switched Laser Tattoo Removal, Picosecond Laser Tattoo Removal, 
          Multicolor Tattoo Removal, Black Ink Tattoo Removal, Colored Tattoo Removal, Tattoo Fading Treatment, 
          Safe Tattoo Removal, and Professional Tattoo Removal services.
          Best tattoo removal treatment Chennai Bangalore, laser tattoo removal specialist Tamil Nadu Karnataka, dermatologist Chennai Bangalore, tattoo removal clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Tattoo Removal Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified dermatologists and tattoo removal specialists providing personalized tattoo removal treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Tattoo removal specialist Chennai Bangalore, laser tattoo removal dermatologist Tamil Nadu Karnataka, tattoo removal doctor Chennai Bangalore, tattoo removal treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          tattoo removal near me, laser tattoo removal near me, dermatologist near me, tattoo removal clinic near me, Q-switched laser tattoo removal near me, best tattoo removal treatment, 
          professional tattoo removal, tattoo removal doctor, tattoo removal skin clinic, tattoo removal dermatology clinic, picosecond laser tattoo removal, multicolor tattoo removal, black ink tattoo removal, 
          colored tattoo removal, tattoo fading treatment, complete tattoo removal, safe tattoo removal, effective tattoo removal, minimal scarring tattoo removal, unwanted tattoo removal, 
          tattoo removal consultation, tattoo removal aftercare, tattoo removal for all skin types, cosmetic tattoo removal dermatology, medical tattoo removal skincare, tattoo removal skin health, 
          tattoo removal skin analysis, tattoo removal treatment prevention, dermatological tattoo removal treatment, tattoo removal skin wellness, tattoo removal therapy, tattoo removal skin problem solutions, 
          tattoo removal for aesthetics, tattoo ink removal, laser tattoo fading, 
          tattoo removal specialist doctor, professional tattoo removal care, advanced tattoo removal treatment, innovative tattoo removal solutions, tattoo removal skin transformation, 
          tattoo-free skin treatment, clear skin tattoo removal therapy, tattoo removal skin renewal, tattoo removal management, tattoo removal for sensitive skin, 
          non-invasive tattoo removal treatment, safe tattoo removal treatment, effective tattoo removal care, proven tattoo removal solutions, personalized tattoo removal treatment, 
          customized tattoo removal therapy, expert tattoo removal care, quality tattoo removal dermatology services, trusted tattoo removal clinic, reliable tattoo removal treatment, 
          affordable tattoo removal care, convenient tattoo removal dermatology, accessible tattoo removal treatment, comprehensive tattoo removal solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button 
              className="ads-modal-nav ads-modal-prev" 
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button 
              className="ads-modal-nav ads-modal-next" 
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tattoremoval;
